var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./table.html"] = require( "./table.html" );




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/content/upload.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("./table.html", true, "views/content/upload.html", false, function(t_2,_parentTemplate) {
if(t_2) { cb(t_2); return; }
parentTemplate = _parentTemplate
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("header"))(env, context, frame, runtime, function(t_4,t_3) {
if(t_4) { cb(t_4); return; }
output += t_3;
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_header(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\r\n<form class=\"table-form sticky-div grid upload-submit\">\r\n\t<div class=\"col-12\">\r\n\t\t<p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"AdminDesktop_AlertNoFileSelected"), env.opts.autoescape);
output += "</p>\r\n\r\n\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Request")),"Subject") == "Rental.ItemImage") {
output += "\r\n\t\t\t<label class=\"button btn-secondary\"> <i class=\"fas fa-upload\"></i> ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"UploadFileSelectButtonText"), env.opts.autoescape);
output += "\r\n\t\t\t\t<input name=\"FileUpload\" accept=\"image/*\" type=\"file\" class=\"ignore-change\" hidden>\r\n\t\t\t</label>\r\n\t\t";
;
}
else {
output += "\r\n\t\t\t<label class=\"button btn-secondary\">\r\n\t\t\t\t<i class=\"fas fa-upload\"></i> ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"UploadFileSelectButtonText"), env.opts.autoescape);
output += "\r\n\t\t\t\t<input name=\"FileUpload\" type=\"file\" class=\"ignore-change\" hidden>\r\n\t\t\t</label>\r\n\t\t";
;
}
output += "\r\n\r\n\t\t<button class=\"button button-default\" data-window-event=\"actionUploadFile\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"UploadFile"), env.opts.autoescape);
output += "</button>\r\n\t\t<hr>\r\n\t\t<p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"DropFile"), env.opts.autoescape);
output += "</p>\r\n\t</div>\r\n</form>\r\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_header: b_header,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/content/upload.html"] , dependencies)